// SignupButtons.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './SignupButtons.css';

// Images
import google from 'images/google.png';

// Components
import SignupButton from './button/SignupButton';

/**
 * SignupButtons
 * 
 * Description
 *  
 * @returns {ReactNode} - SignupButtons.
 */
const SignupButtons = React.memo(({ onEmailClick, onGoogleClick }) => {

    // ------ CONTEXT ------ //

    // Theme Context
    const { theme } = useTheme();

    return (

        <div className="signup-buttons-container">

        {/* "OR" BAR */}
        <div className="signup-buttons-spacer">

            <div className="signup-buttons-spacer-bar"
                style={{
                    color: theme.foregroundMuted
                }}>

            </div>
            <div className="signup-buttons-spacer-or"
                style={{
                    color: theme.foreground
                }}>
                OR
            </div>
            <div className="signup-buttons-spacer-bar"
                style={{
                    color: theme.foregroundMuted
                }}>

            </div>

        </div>

            {/* GOOGLE SIGNUP BUTTON */}
            <SignupButton
                image={google}
                label="Continue with Google"
                onClick={onGoogleClick}
            />

            {/* "OR" BAR */}
            <div className="signup-buttons-spacer">

                <div className="signup-buttons-spacer-bar"
                    style={{
                        color: theme.foregroundMuted
                    }}>

                </div>
                <div className="signup-buttons-spacer-or"
                    style={{
                        color: theme.foreground
                    }}>
                    OR
                </div>
                <div className="signup-buttons-spacer-bar"
                    style={{
                        color: theme.foregroundMuted
                    }}>

                </div>

            </div>

            {/* EMAIL SIGN UP WRAPPER */}
            <div className="signup-buttons-email-wrapper">

                {/* EMAIL SIGN UP */}
                <div className="signup-buttons-email"
                    onClick={onEmailClick}
                    style={{
                        color: theme.foreground
                    }}>
                    Sign up free with email.
                </div>

                {/* EMAIL CC */}
                <div className="signup-buttons-cc"
                    style={{
                        color: theme.foregroundMuted
                    }}>
                    No credit card required
                </div>

            </div>

        </div>
    );

});

// Dev Tools
SignupButtons.displayName = 'SignupButtons';

export default SignupButtons;

